import type { IconSvgObject } from './types';

const JavaScriptIcon: IconSvgObject = [
  ["path", { d: "M18.5 21.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5H18.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 12V15.8369C11.5 17.0315 10.5315 18 9.33688 18C8.5724 18 7.86214 17.7243 7.5 17M17.8862 13C17.6116 12.4174 16.8708 12 16 12C14.8954 12 14 12.6716 14 13.5C14 15.5666 18 14.4334 18 16.5C18 17.3284 17.1046 18 16 18C15.1292 18 14.3884 17.5826 14.1138 17", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default JavaScriptIcon;
